function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Box from '../Box';
const Radio = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    field,
    form,
    label,
    sx,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: "input",
    type: "radio"
  }, field, props, {
    __css: {
      mr: '4px'
    }
  }));
});
Radio.propTypes = {};
Radio.defaultProps = {};
Radio.displayName = 'Radio';
export default Radio;